import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RoomBookingSearchAlternativeTime from './RoomBookingSearchAlternativeTime';
import ModalTrigger from './ModalTrigger';

export default class RoomBookingSearchResults extends Component {
  static propTypes = {
    availableRooms: PropTypes.array,
    unavailableRooms: PropTypes.array,
    alternativeTimes: PropTypes.array,
    show: PropTypes.bool,
    timezone: PropTypes.string,
    searchCallback: PropTypes.func,
  }

  render() {
    let content;
    // Show the available rooms if there are any
    if (this.props.availableRooms.length > 0) {
      content = (
        <div id="rooms-display" hidden={!this.props.show}>
          {
            this.props.availableRooms.map((room) => {
              let roomDisplay = <div className="RoomSearch-room">{room.name}</div>;
              let attributesDropdown;

              if (room.attributes_list.length) {
                roomDisplay = (
                  <div className="RoomSearch-room">
                    {room.name}
                  </div>
                );

                const features = [];
                room.attributes_list.forEach((feature, i) => {
                  features.push(<li key={`${room.name}-feature-${i + 1}`} className="u-inline-block u-mr-3">{feature}</li>);
                });

                attributesDropdown = (
                  <ul className="u-block u-m-0 u-text-sm u-text-grey">{features}</ul>
                );
              }

              return (
                <div className="RoomSearch-result u-py-2 u-clearfix" key={room.name}>
                  <ModalTrigger
                    triggerLabel="Book"
                    triggerClassName="Button Button--xsmall u-float-right"
                    async
                    asyncUrl={room.booking_url} />
                  {roomDisplay}
                  {attributesDropdown}
                </div>
              );
            })
          }
        </div>
      );
      // Show the alternative time suggestions if there are any
    } else if (this.props.alternativeTimes.length > 0) {
      content = (
        <div>
          There are no available rooms at this time
          <br />
          Here are times you could find rooms
          <div className="u-mt-5">
            {
              this.props.alternativeTimes.map((alternativeTime) =>
                <RoomBookingSearchAlternativeTime
                  startTime={alternativeTime.start_time}
                  endTime={alternativeTime.end_time}
                  timezone={this.props.timezone}
                  searchCallback={this.props.searchCallback}
                  key={moment(alternativeTime.start_time).format('hh:mm')}
                />
              )
            }
          </div>
        </div>
      );
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}
